/*
 * @Author: ymuser 2239526027@qq.com
 * @Date: 2022-08-16 11:02:37
 * @LastEditors: ymuser yemeng@authine.com
 * @LastEditTime: 2023-04-13 14:48:46
 * @FilePath: \nsc-frontend\entries\portal\extends\routes.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import applicationRoutes from "../src/routes/applicationRoutes";
// import site from '@/config/site';
// import RouterView from '@/views/common-view/index.vue';
export default {
    formDetail: {
        path: "/form/detail",
        name: "form-detail",
        component: () => import("@/views/form/form-detail.vue"),
    },
    // 二开  自定义表单  开始
    newapplicationone: {
        path: "/newapplicationone",
        name: "newapplicationone",
        component: () => import("../../portal/extends/views/newapplicationone/newapplicationone.vue"),
    },
    newapplicationInfo: {
        path: "/newapplicationInfo",
        name: "newapplicationInfo",
        component: () => import("../../portal/extends/views/newapplicationone/newapplicationInfo.vue"),
    },
    newapplicationApproval: {
        path: "/newapplicationApproval",
        name: "newapplicationApproval",
        component: () => import("../../portal/extends/views/newapplicationone/newapplicationApproval.vue"),
    },
    Approval: {
        path: "/Approval",
        name: "Approval",
        component: () => import("../../portal/extends/views/newapplicationone/Approval.vue"),
    },
    newapplicationtwo: {
        path: "/newapplicationtwo",
        name: "newapplicationtwo",
        component: () => import("../../portal/extends/views/newapplicationtwo/newapplicationtwo.vue"),
    },
    newapplicationInfonew: {
        path: "/newapplicationInfonew",
        name: "newapplicationInfonew",
        component: () => import("../../portal/extends/views/newapplicationtwo/newapplicationInfonew.vue"),
    },
    newapplicationApp: {
        path: "/newapplicationApp",
        name: "newapplicationApp",
        component: () => import("../../portal/extends/views/newapplicationtwo/newapplicationApp.vue"),
    },
    Approvalnew: {
        path: "/Approvalnew",
        name: "Approvalnew",
        component: () => import("../../portal/extends/views/newapplicationtwo/Approvalnew.vue"),
    },
    // 自定义表单New chop-Report-Statistics
    Statistics: {
        path: "/Statistics",
        name: "Statistics",
        component: () => import("./views/Statistics/statistics.vue"),
    },
    // 自定义表单New chop-Report-Statistics
    ApproverUser: {
        path: "/ApproverMent",
        name: "ApproverMent",
        component: () => import("./views/ApproverUser/ApproverMent.vue"),
    },
    // 自定义表单New contractPONum数据源
    mUpdateContractpoView: {
        path: "/mUpdateContractpoView",
        name: "mUpdateContractpoView",
        component: () => import("./views/contractPONum/mUpdateContractpoView.vue"),
    },
    // 自定义表单New chop-Report-Statistics
    ApproverUserSupper: {
        path: "/SuperDelegation",
        name: "SuperDelegation",
        component: () => import("./views/ApproverUserSupper/SuperDelegation.vue"),
    },
    // 自定义表单New Chop Delegation Report
    NewChopDelegationReport: {
        path: "/DelegationReport",
        name: "DelegationReport",
        component: () => import("./views/NewChopDelegationReport/NewChopDelegationReport.vue"),
    },
    //结束
    // 二开totalRewards页面
    totalRewards: {
        path: "/totalRewards",
        name: "totalRewards",
        component: () => import("./views/totalRewards/totalRewards.vue"),
    },
    // 二开 bestYou页面 开始
    bestYou: {
        path: "/bestyou",
        name: "bestyou",
        component: () => import("./views/bestYou/bestYou.vue"),
    },
    //二开IT mobile页面开始
    MobileBillReport: {
        path: "/MobileBillReport",
        name: "MobileBillReport",
        component: () => import("./views/MobileBillReport/MobileBillReport.vue"),
    },
    //二开Acknowledgement页面开始
    AcknowledgementTask: {
        path: "/AcknowledgementTask",
        name: "AcknowledgementTask",
        component: () => import("./views/Acknowledgement/AcknowledgementTask.vue"),
    },
    //二开assetManagement页面开始
    assetManagement: {
        path: "/assetManagement",
        name: "assetManagement",
        component: () => import("./views/assetManagement/assetManagement.vue"),
    },
    //二开 StartSurvey 页面开始
    StartSurvey: {
        path: "/StartSurvey",
        name: "StartSurvey",
        component: () => import("./views/StartSurvey/StartSurvey.vue"),
    },
    SurveyDetail: {
        path: "/SurveyDetail",
        name: "SurveyDetail",
        component: () => import("./views/StartSurvey/SurveyDetail.vue"),
    },
    DataDetail: {
        path: "/DataDetail",
        name: "DataDetail",
        component: () => import("./views/StartSurvey/DataDetail.vue"),
    },
    //二开loginerror页面开始
    loginError: {
        path: "/loginError",
        name: "loginError",
        component: () => import("./views/loginError/loginError.vue"),
    },
    authorityError: {
        path: "/authorityError",
        name: "authorityError",
        component: () => import("./views/loginError/authorityError.vue"),
    },
    //二开logincandidate页面结束
    //手机登录pc error页面
    deviceError: {
        path: "/deviceError",
        name: "deviceError",
        component: () => import("./views/loginError/deviceError.vue"),
    },
    loginCandidate: {
        path: "/login-candidate",
        name: "loginCandidate",
        component: () => import("./views/loginCandidate/login-candidate.vue"),
    },
    application: {
        application: Object.assign({}, applicationRoutes.infoPath, { children: [
                ...applicationRoutes.infoChildren,
                {
                    path: "testApplication/:schemaCode",
                    name: "testApplication",
                    component: () => import("./views/application-list.vue"),
                },
            ] }),
    },
    // 二开  调查问卷自定义表单  开始
    overseasRemittanceQuestion: {
        path: "/form/orQuestionnaireCreate",
        name: "orQuestionnaireCreate",
        component: () => import("./views/overseasRemittance/orQuestionnaireCreate.vue"),
        meta: {
            title: "Create Form-Overseas Remittance",
        },
    },
    overseasRemittanceApprove: {
        path: "/form/orQuestionnaireApprove",
        name: "orQuestionnaireApprove",
        component: () => import("./views/overseasRemittance/orQuestionnaireApprove.vue"),
        meta: {
            title: "View Form-Overseas Remittance",
        },
    },
    // 二开  调查问卷自定义表单  结束
    // 二开  expatInformation自定义表单  开始
    expatInformation: {
        path: "/form/createExpatInformation",
        name: "createExpatInformation",
        component: () => import("./views/expats/createExpatInformation.vue"),
        meta: {
            title: "Create Expat_Information",
        },
    },
    familyInformation: {
        path: "/form/familyInformation",
        name: "familyInformation",
        component: () => import("./views/expats/familyInformation.vue"),
        meta: {
            title: "Create Family_Information",
        },
    },
    // 二开  expatInformation自定义表单  结束
    //   二开 personal_DataTemplatenew页面 开始
    PersonalDataTemplate: {
        path: "/PersonalDataTemplate",
        name: "PersonalDataTemplate",
        component: () => import("./views/PersonalDataTemplate/PersonalDataTemplate.vue"),
    },
    //二开 personal_DataTemplatenew页面 结束
    //二开OD开始
    ODGenerateCommunicationLetter: {
        path: "/ODGenerateCommunicationLetter",
        name: "ODGenerateCommunicationLetter",
        component: () => import("./views/OD/onboardingLetter.vue"),
    },
    //二开OD System APPROVE 
    //二开OD开始
    ODSystemApprove: {
        path: "/ODsystemApprove",
        name: "ODsystemApprove",
        component: () => import("./views/OD/systemApprove.vue"),
    },
};
